module.exports = "<div #subscriberDiv></div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/open-tok/subscriber/subscriber.component.html
// module id = ../../../../../src/app/shared/components/open-tok/subscriber/subscriber.component.html
// module chunks = main